import React from 'react';

const ApprovalConfigComponentLoadable = React.lazy(() => import('./ApprovalConfigComponent'));
const VolumetricApprovalComponentLoadable = React.lazy(() => import('./VolumetricApprovalComponent'));

export {
  ApprovalConfigComponentLoadable,
  VolumetricApprovalComponentLoadable,
};
